

const ContactPage = () => {
  return <></>;
};

export default ContactPage;
